import React from 'react';
import { NavLink } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

/**
 * 导航菜单项组件
 * @param {Object} props - 组件属性
 * @param {string} props.linkTo - 链接地址
 * @param {boolean} props.isActive - 是否为激活状态
 * @param {string} props.messageId - 显示文本的国际化ID
 * @param {string} props.className - 自定义类名
 * @param {Object} props.customStyle - 自定义样式
 * @param {string} props.iconClassName - 图标类名
 * @param {Object} props.messageValues - 国际化消息的参数
 * @param {React.ReactNode} props.children - 子元素
 * @param {function} props.onClick - 点击事件处理函数
 */
const NavMenuItem = ({
  linkTo,
  isActive,
  messageId,
  className,
  customStyle,
  iconClassName,
  messageValues,
  children,
  onClick,
  styles
}) => {
  return (
    <li className={className} style={customStyle}>
      <span className={isActive}>
        {linkTo ? (
          <NavLink to={linkTo} onClick={onClick}>
            {iconClassName && <i className={iconClassName} />}
            <FormattedMessage id={messageId} values={messageValues || {}} />
          </NavLink>
        ) : (
          <>
            {iconClassName && <i className={iconClassName} />}
            <FormattedMessage id={messageId} values={messageValues || {}} />
          </>
        )}
        <i className={styles.line} />
      </span>
      {children}
    </li>
  );
};

NavMenuItem.propTypes = {
  linkTo: PropTypes.string,
  isActive: PropTypes.string,
  messageId: PropTypes.string.isRequired,
  className: PropTypes.string,
  customStyle: PropTypes.object,
  iconClassName: PropTypes.string,
  messageValues: PropTypes.object,
  children: PropTypes.node,
  onClick: PropTypes.func,
  styles: PropTypes.object.isRequired
};

export default NavMenuItem; 